import React, { useState, useEffect } from 'react';
import OhTechYesHeader from '../components/OhTechYesHeader';
import HypeHero from '../components/HypeHero';
import HypeArticleCard from '../components/HypeArticleCard';
import DisplayAd from '../components/DisplayAd';
import NativeAd from '../components/NativeAd';
import { safeFetchJson } from '../lib/safeFetch';

const OhTechYesHome = () => {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    // Fetch real articles from API
    const fetchArticles = async () => {
      const result = await safeFetchJson(`${process.env.REACT_APP_BACKEND_URL}/api/articles?limit=12`);
      
      if (result.ok && result.data) {
        setArticles(result.data);
      } else if (result.error === 'backend_not_configured') {
        console.info('Articles backend not yet configured');
      } else if (result.error) {
        console.error('Error fetching articles:', result.error);
      }
      
      setLoading(false);
    };
    
    fetchArticles();
  }, []);
  
  return (
    <div className="min-h-screen bg-[#0a0a0b]">
      <OhTechYesHeader />
      
      <HypeHero />
      
      {/* Latest Articles Section */}
      {articles.length > 0 && (
        <div className="max-w-[1400px] mx-auto px-4 py-16">
          <div className="flex items-center justify-between mb-8">
            <h2 
              className="text-5xl font-black text-gradient"
              style={{fontFamily: 'Space Grotesk, sans-serif'}}
            >
              LATEST DROPS
            </h2>
            <button className="text-[#00ff88] font-bold uppercase text-sm hover:text-[#00d9ff] transition-colors">
              View All →
            </button>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {loading ? (
              <div className="col-span-3 text-center text-green-400 py-12">Loading amazing content...</div>
            ) : articles.length === 0 ? (
              <div className="col-span-3 text-center text-gray-400 py-12">No articles yet</div>
            ) : (
              articles.slice(0, 6).map((article, index) => (
                <HypeArticleCard 
                  key={article.id} 
                  article={article}
                  featured={index === 0}
                />
              ))
            )}
          </div>
        </div>
      )}
      
      {/* Trending Section */}
      {articles.length > 6 && (
        <div className="bg-gradient-to-b from-[#1a1a1f] to-[#0a0a0b] py-16">
          <div className="max-w-[1400px] mx-auto px-4">
            <h2 
              className="text-5xl font-black text-gradient mb-8"
              style={{fontFamily: 'Space Grotesk, sans-serif'}}
            >
              🔥 TRENDING NOW
            </h2>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {articles.slice(6, 10).map((article) => (
                <HypeArticleCard key={article.id} article={article} />
              ))}
            </div>
          </div>
        </div>
      )}
      
      {/* Footer */}
      <footer className="bg-[#0a0a0b] border-t-2 border-[#00ff88] py-12">
        <div className="max-w-[1400px] mx-auto px-4 text-center">
          <h3 
            className="text-4xl font-black text-gradient mb-4"
            style={{fontFamily: 'Space Grotesk, sans-serif'}}
          >
            OH TECH YES
          </h3>
          <p className="text-[#b4b4b9] mb-6">
            The tech site that actually gets you hyped.
          </p>
          <div className="flex justify-center gap-6 text-sm text-[#a1a1aa]">
            <a href="/about" className="hover:text-[#00ff88] transition-colors">About</a>
            <a href="/contact" className="hover:text-[#00ff88] transition-colors">Contact</a>
            <a href="/advertise" className="hover:text-[#00ff88] transition-colors">Advertise</a>
            <a href="/privacy" className="hover:text-[#00ff88] transition-colors">Privacy</a>
          </div>
          <div className="mt-6 text-xs text-[#a1a1aa]">
            © 2026 OhTechYes.com - All rights reserved.
          </div>
        </div>
      </footer>
    </div>
  );
};

export default OhTechYesHome;
